import axios from 'axios'//
const request = axios.create({
    baseURL:"https://mdc.maiyuan.online/v2/api/"
})
 
export default request